<script>
  export default {
    name: 'form-item-render',
    props: {
      node: {
        type: Object
      }
    },
    inject: ['formData', 'subData', 'row', 'rowIndex'],
    computed: {
      rules () {
        const {formData, node, row, rowIndex} = this
        let {props: {rules, ruleFn}} = node

        if (typeof ruleFn === 'function') {
          rules = rules.concat(ruleFn({
            field: node,
            formData: formData,
            row,
            rowIndex
          }) || [])
        }

        return rules.map(v => {
          if (typeof v === 'function') {
            return v({
              field: node,
              formData: formData,
              row,
              rowIndex
            })
          }
          return v
        })
      }
    },
    render (h) {
      const {viewContent, fieldProps = {}, props, targetApiName, parentKey} = this.node
      const {rowIndex, rules} = this
      const styleType = typeof rowIndex === 'number' ? 'mini' : 'medium'
      // labelWidth={styleType === 'mini' ? '60px' : '124px'}
      return (
        <sy-form-item
          {...{
            props: {
              ...props,
              hideLabel: fieldProps.hideLabel
            }
          }}
          prop={
            `${
              typeof rowIndex === 'number'
                ? parentKey + '.' + rowIndex + '.'
                : ''
            }${targetApiName}`
          }
          rules={rules}
          styleType={styleType}
        >
          <render viewContent={viewContent}/>
        </sy-form-item>
      )
    }
  }
</script>
